import { IProduct, ISelectedProduct } from 'types/interfaces';

export default function sortProductsBySelection(selectedProductsIds: ISelectedProduct[], products: IProduct[]) {
  const orderedProducts: IProduct[] = [];

  selectedProductsIds.forEach((selectedProduct, index) => {
    const product = products.find(product => product.contentId === selectedProduct.contentId);

    if (product) {
      orderedProducts.splice(index, 0, product);
    }
  });

  return orderedProducts;
}
